const ApiPath = {
  BankDeposit: "ms-pos/bank-deposit",
  DailyRecords: "ms-pos/daily-record",
  Expense: "ms-pos/expense",
  GenerateReport: "ms-pos/report",
  GetStations: "ms-pos/station",
  GetUser: "ms-profile/user",
  GetUsers: "ms-profile/user/users",
  KeyAccount: "ms-pos/key-accounts",
  Login: "ms-profile/user/login",
  Logout: "ms-profile/user/logout",
  Product: "ms-stock/product",
  Refresh: "ms-profile/user/refresh",
  ShiftRecords: "ms-pos/shift",
  Station: "ms-pos/station",
  Storage: "ms-storage/upload",
  Transaction: "ms-pos/transaction",
  Delivery: "ms-pos/delivery",
  Category: "ms-stock/category",
  PurchaseOrder: "ms-stock/order",
};

export default ApiPath;
